var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[(_vm.isReady)?_c('Navbar',{attrs:{"settings":_vm.settings}}):_vm._e(),_c('div',{staticClass:"main-content"},[(_vm.isReady)?_c('router-view'):_vm._e()],1),(_vm.isReady)?_c('Footer',{attrs:{"settings":_vm.settings}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }